export const profile = {
  firstName: "Nikolay",
  lastName: "Lebedinsky",
  metaDescription:
    "I design the architecture, lead the team and build the backend. Production systems for Web3, real-time data and infrastructure.",
  headline:
    "Backend developer designing and delivering production systems for Web3 projects.",
  supporting:
    "From defining the problem and consulting through architecture, implementation and reliable production operation.",
};

export const workingRange = [
  "Application backends",
  "Real-time data pipelines",
  "Distributed platforms",
  "Infrastructure",
];

export const personalFile = {
  education: [
    {
      institution: "Saint Petersburg State Marine Technical University",
      credential: "Bachelor's degree, Informatics and computer science",
      period: "Sep 2019 – Jul 2023",
    },
    {
      institution: "OTUS Online Education",
      credential: "Scalable systems design",
      period: "Oct 2024 – May 2025",
    },
  ],
  credentials: [
    {
      title: "Highload Architect",
      issuer: "OTUS Online Education",
      issued: "May 2025",
    },
    {
      title: "EF SET English Certificate — C1 Advanced (65/100)",
      issuer: "EF SET",
      issued: "Dec 2024",
    },
  ],
  experience: [
    {
      company: "Rock'n'Block",
      roles: [
        {
          title: "Lead Software Engineer",
          period: "Dec 2024 - Present",
          summary:
            "System architecture, feature decomposition, code review, and technical guidance for a team of three backend engineers.",
        },
        {
          title: "DevOps Lead",
          period: "Aug 2024 - Present",
          summary:
            "Security, availability, CI/CD, deployment workflows, and infrastructure resilience across multiple projects.",
        },
        {
          title: "Backend Developer",
          period: "Mar 2023 – Present",
          summary:
            "Backend systems for Web3 products, marketplaces, decentralized exchanges, internal tools, and interconnected ecosystems.",
        },
      ],
    },
    {
      company: "St. Petersburg SMTU",
      roles: [
        {
          title: "Python Developer",
          period: "Apr 2022 - Apr 2023",
          summary:
            "Telegram bots, a plastic usage tracker for 3D printing, and Linux server management.",
        },
      ],
    },
  ],
  colleagueSignals: [
    "Calm under pressure",
    "Clear communication",
    "Reliable delivery",
    "Mentorship",
  ],
  outsideWork: [
    {
      label: "Custom keyboards / QMK",
      detail: "Firmware, layouts, and the pursuit of better input tools.",
      href: "https://github.com/joxerx/qmk_firmware",
    },
  ],
};

export const selectedExperience = [
  {
    index: "001",
    confidentiality: "NDA",
    domain: "Payments / Web3",
    title: "Multi-chain payment core",
    role: ["Architecture", "Development", "Performance"],
    summary:
      "Designed and built network-isolated workers and Celery queues, eliminating transaction backlogs under sustained peak traffic.",
    metrics: ["5+ networks", "200+ TPS", "3× peak traffic"],
    status: "Production system",
  },
  {
    index: "002",
    confidentiality: "NDA",
    domain: "Real-time systems / Web3",
    title: "Real-time Solana indexer",
    role: ["Architecture", "Leadership", "Development"],
    summary:
      "Designed the system end to end and led the team through delivery; it now runs reliably in production as a core platform component.",
    metrics: ["20+ protocols", "1K+ events/s", "<1 ms processing"],
    status: "Production / Core",
  },
  {
    index: "003",
    confidentiality: "NDA",
    domain: "Data pipeline / Performance",
    title: "Growing-data pipeline recovery",
    role: ["Profiling", "Optimization", "Caching"],
    summary:
      "Traced queue growth to slow node calls and database reads, then restored throughput with targeted indexes and selective Redis caching.",
    metrics: ["$50M+ TVL", "$4B+ volume", "100× throughput"],
    status: "Performance recovery",
  },
  {
    index: "004",
    confidentiality: "NDA",
    domain: "On-chain analytics / Real-time",
    title: "Multi-chain activity signals",
    role: ["Architecture", "Leadership", "Performance"],
    summary:
      "Designed the architecture and led the team building a real-time user-activity and statistics system across EVM and Solana.",
    metrics: ["5+ networks", "5B+ records", "≤3 s trigger-to-send"],
    status: "Real-time system",
  },
];

export const publicSignals = [
  {
    kind: "Merged PR",
    label: "erigontech/erigon #24796",
    detail: "Prevented snapshot deletion for empty step ranges",
    href: "https://github.com/erigontech/erigon/pull/24796",
  },
  {
    kind: "Merged PR",
    label: "ethereum/execution-apis #942",
    detail: "Allow account overrides without storage fields",
    href: "https://github.com/ethereum/execution-apis/pull/942",
  },
  {
    kind: "Merged PR",
    label: "bitcoin-python-async-rpc #22",
    detail: "Fixed an unexpected KeyError in async RPC handling",
    href: "https://github.com/bibajz/bitcoin-python-async-rpc/pull/22",
  },
  {
    kind: "PR",
    label: "ApeWorX/web3.py #3887",
    detail: "Time-based gas price strategies for AsyncWeb3",
    href: "https://github.com/ApeWorX/web3.py/pull/3887",
  },
  {
    kind: "Project",
    label: "Distributed Systems Lab",
    detail: "joxerx/otus-highload",
    href: "https://github.com/joxerx/otus-highload",
  },
];

export const contacts = [
  {
    label: "Email",
    value: "nikolay@lebed.dev",
    href: "mailto:nikolay@lebed.dev",
    external: false,
  },
  {
    label: "GitHub",
    value: "@joxerx",
    href: "https://github.com/joxerx",
    external: true,
  },
  {
    label: "Telegram",
    value: "@joxerx",
    href: "https://t.me/joxerx",
    external: true,
  },
  {
    label: "LinkedIn",
    value: "Nikolay Lebedinsky",
    href: "https://www.linkedin.com/in/nikolay-lebedinsky/",
    external: true,
  },
];

export const stack = [
  "Go",
  "Rust",
  "Python",
  "PostgreSQL",
  "ClickHouse",
  "Redis",
  "Docker",
  "Kubernetes",
];
